import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { createTheme, Theme, ThemeProvider } from "@mui/material/styles";
import MUIRichTextEditor from "mui-rte";
import { stateToHTML } from "draft-js-export-html";

const Editor = (props) => {
  // Redux state
  let [resetDefault, setResetDefault] = useState(false);
  const { assetData } = useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (assetData && assetData.asset_uid) {
      setResetDefault(true);
      setTimeout(() => {
        setResetDefault(false);
      }, [100]);
    }
  }, [assetData]);

  const defaultTheme = createTheme({
    palette: {
      primary: {
        main: "#000000",
      },
    },
  });

  const muiRteTheme = {
    overrides: {
      MUIRichTextEditor: {
        root: {
          border: "1px solid #EEEEEE",
          borderRadius: "15px",
          backgroundColor: "#FFFFFF",
        },
        container: {
          display: "flex",
          borderRadius: "15px",
          flexDirection: "column-reverse",
        },
        editor: {
          backgroundColor: "#FFFFFF",
          padding: "20px",
          height: "150px",
          maxHeight: "150px",
          borderRadius: "15px 15px 0 0",
          overflow: "auto",
        },
        toolbar: {
          backgroundColor: "#EEEEEE",
          borderRadius: "0 0 15px 15px",
        },
        placeHolder: {
          backgroundColor: "#FFFFFF",
          paddingLeft: 20,
          width: "inherit",
        },
        anchorLink: {
          color: "#333333",
          textDecoration: "underline",
        },
      },
    },
  };

  Object.assign(defaultTheme, muiRteTheme);

  const changeText = (editorState) => {
    const contentState = editorState.getCurrentContent();
    if(stateToHTML(contentState).trim() != '<p><br></p>'){
        props.change(stateToHTML(contentState));
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      {!resetDefault && (
        <MUIRichTextEditor
          controls={[
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "undo",
            "redo",
          ]}
          defaultValue={""}
          toolbarButtonSize="small"
          label="Start typing..."
          onChange={changeText}
          readOnly={props.readOnly}
        />
      )}
    </ThemeProvider>
  );
};

export default Editor;
